<template>
  <footer class="footer">
    <div class="container">
      <div
        class="row align-items-center justify-content-md-between justify-content-sm-center"
      >
        <div class="col-md-6">
          <div class="copyright">
            &copy; {{ year }}
            Aldtek
          </div>
        </div>
        <div class="col-md-6">
          <ul class="nav nav-footer justify-content-end">
            <li class="nav-item">
              <a
                href="https://www.creative-tim.com"
                class="nav-link"
                target="_blank"
                rel="noopener"
                >Template by Creative Tim</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "app-footer",
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style>
</style>
